import WebApp from '@twa-dev/sdk'
import { useEffect } from 'react'

export function useTelegram() {
  useEffect(() => {
    WebApp.ready()
    WebApp.expand()
  }, [])

  return {
    webApp:      WebApp,
    initData:    WebApp.initData,
    tgUser:      WebApp.initDataUnsafe?.user,
    colorScheme: WebApp.colorScheme,
    haptic:      WebApp.HapticFeedback,
    mainButton:  WebApp.MainButton,
    close:       () => WebApp.close(),
    confirm:     (msg: string, cb: (ok: boolean) => void) => WebApp.showConfirm(msg, cb),
  }
}

/** Форматирует приветствие по имени из Telegram initData */
export function useGreeting(): string {
  const user = WebApp.initDataUnsafe?.user
  const name = user?.first_name?.trim()
  return name ? `Привет, ${name}` : 'Привет'
}

/** Возвращает фото-url пользователя из Telegram (недоступно в Mini App — always undefined) */
export function useTgUser() {
  return WebApp.initDataUnsafe?.user ?? null
}
